import React from 'react';

/** Fixed slot so every card aligns the + / counter on the right edge. */
export const PRODUCT_CARD_QTY_SLOT_WIDTH = 96;

const ProductCardPriceQtyRow = ({ price, hint = null, quantityControl, className = '' }) => (
    <div className={`product-card-price-qty-row d-flex w-100 align-items-start gap-8 ${className}`}>
        <div className="product-card__price flex-grow-1 min-w-0">
            {price}
            {hint}
        </div>
        <div
            className="product-card-price-qty-row__slot flex-shrink-0 d-flex justify-content-end align-items-start"
        >
            {quantityControl}
        </div>
    </div>
);

export default ProductCardPriceQtyRow;
